import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "variant__form" };
import { onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import ArticleCartInput from "@astina/paloma-shop-common-ui/src/components/ArticleCartInput.vue";
import config from '../services/PortalConfig';
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductArticleRow',
    props: {
        variant: {},
        options: {},
        initialQuantity: {},
        markSelected: { type: Boolean }
    },
    emits: [
        'select',
        'cart-input-change',
        'input-focus',
        'input-blur',
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const emit = __emit;
        const props = __props;
        const active = ref(false);
        const cartItem = ref(null);
        const allowOrderingUnitSelection = ref(config.articleOrderingUnitSelection === 'allow');
        onMounted(() => active.value = RouterUtils.singleParam(route, 'sku') === props.variant.sku);
        function select() {
            emit('select', props.variant);
        }
        function onCartInputChange(itemDraft) {
            cartItem.value = itemDraft;
            emit('cart-input-change', itemDraft);
        }
        watch(() => route.params, reset);
        function reset() {
            active.value = RouterUtils.singleParam(route, 'sku') === props.variant.sku;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["variant", { 'variant--unavailable': !__props.variant.availability?.available, 'variant--selected': __props.markSelected && cartItem.value && cartItem.value.quantity > 0, 'variant--active': active.value }])
            }, [
                _createElementVNode("div", {
                    class: "variant__sku",
                    onClick: select
                }, _toDisplayString(__props.variant.sku), 1),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (!__props.options)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "variant__name",
                        onClick: select
                    }, _toDisplayString(__props.variant.name), 1))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.options, (option, type) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "variant__options",
                            key: type,
                            onClick: select
                        }, _toDisplayString(__props.variant.options[type].value), 1));
                    }), 128)),
                _cache[3] || (_cache[3] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    (__props.variant.price)
                        ? (_openBlock(), _createBlock(ArticleCartInput, {
                            key: 0,
                            variant: __props.variant,
                            disabled: !__props.variant.availability?.available,
                            "initial-quantity": __props.initialQuantity ?? 0,
                            "allow-ordering-unit-selection": allowOrderingUnitSelection.value,
                            onChange: onCartInputChange,
                            onFocus: _cache[0] || (_cache[0] = ($event) => (emit('input-focus'))),
                            onBlur: _cache[1] || (_cache[1] = ($event) => (emit('input-blur')))
                        }, null, 8, ["variant", "disabled", "initial-quantity", "allow-ordering-unit-selection"]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
